import React from 'react';
import classNames from 'classnames/bind';
import { Card, Text } from '@beef/ui-kit';
import { Picture } from "../Picture";
import { AppButtons } from "./components/AppButtons";
import style from "./styles.module.pcss";
import IconQrArrow from "../../assets/svg/qr_arrow.svg";
var cn = classNames.bind(style);
var AppBanner = function AppBanner(_ref) {
  var title = _ref.title,
    text = _ref.text,
    img = _ref.img,
    _onClick = _ref.onClick,
    _ref$appButtons = _ref.appButtons,
    appButtons = _ref$appButtons === void 0 ? {} : _ref$appButtons,
    qrCode = _ref.qrCode,
    _ref$ageCategory = _ref.ageCategory,
    ageCategory = _ref$ageCategory === void 0 ? '12+' : _ref$ageCategory;
  return /*#__PURE__*/React.createElement(Card, {
    className: cn('container'),
    "data-t-id": "components-AppBanner"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('details'),
    "data-t-id": "components-AppBanner"
  }, title && /*#__PURE__*/React.createElement(Text, {
    size: "size1-m"
  }, title), text && /*#__PURE__*/React.createElement("div", {
    className: cn('details__text')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-r-s"
  }, text)), /*#__PURE__*/React.createElement("div", {
    className: cn('download-actions')
  }, Object.keys(appButtons).length > 0 && /*#__PURE__*/React.createElement("div", {
    className: cn('download-actions__btn')
  }, /*#__PURE__*/React.createElement(AppButtons, {
    appButtons: appButtons,
    onClick: function onClick(link, index) {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick(link, index);
    }
  })), (qrCode === null || qrCode === void 0 ? void 0 : qrCode.img) && /*#__PURE__*/React.createElement("div", {
    className: cn('download-actions__qr')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('qr')
  }, /*#__PURE__*/React.createElement(Picture, {
    alt: "qrCode",
    className: cn('qr__img'),
    src: qrCode.img
  })), (qrCode === null || qrCode === void 0 ? void 0 : qrCode.text) && /*#__PURE__*/React.createElement("div", {
    className: cn('qr__text')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey50",
    size: "size7-r"
  }, qrCode.text, /*#__PURE__*/React.createElement(IconQrArrow, {
    className: cn('arrow-icon'),
    "data-t-id": "components-AppBanner"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: cn('img-wrapper')
  }, (img === null || img === void 0 ? void 0 : img.src) && /*#__PURE__*/React.createElement(Picture, {
    alt: img.alt,
    className: cn('img'),
    fallbackSrc: img.src,
    lazy: true,
    source: img.source,
    src: img.src,
    title: img.title
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('age-category')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey40",
    size: "size3-m"
  }, ageCategory)));
};
export { AppBanner };